import axios from "axios";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import SEO from "../../../components/SEO";
import { BASEURL } from "../../../utilites";
import Modal from "../../../components/Dashboard/Modal";
import { useDispatch } from "react-redux";
import allActions from "../../../Store/action";
import OnboardingAppointmentForm from "./OnboardingAppointmentForm";

const OnBoardingBookAppointment = ({setStep, license, isQuestionnaireCompleted, isMessageSent, isPdfDownloaded}) => {
  const [leadDetails, setLeadDetails] = useState();
  const [operatorAppointments, setOperatorAppointments] = useState([]);
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const [closedByApi, setClosedByApi] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const lead = searchParams.get("lead");
    const customer = searchParams.get("customer");
    const operator = searchParams.get("operator");

    if (!lead || !customer || !operator) return;

    setLoading(true);
    axios
      .get(
        `${BASEURL}/api/booking/${lead}/${customer}/${operator}`
      )
      .then((response) => {
        setLeadDetails(response.data.data.lead);
        setOperatorAppointments(response.data.data.appointments);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [searchParams]);


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const emailFromUrl = params.get("email");
    if (emailFromUrl) {
      setEmail(emailFromUrl);
    }
  }, []);

  const handleSubmit = () => {
    dispatch(allActions.global.Loader(true));
    axios
      .post(`${BASEURL}/api/booking/check-user`, { email })
      .then((res) => {
        const { success, data } = res.data;

        if (success && data?.lead && data?.customer && data?.operator) {
          setClosedByApi(true);
          const { lead, customer, operator } = data;
          const newUrl = `${window.location.origin}${window.location.pathname}?lead=${lead}&customer=${customer}&operator=${operator}`;
          window.location.href = newUrl;
        }
        dispatch(allActions.global.Loader(false));
      })
      .catch((err) => {
        setClosedByApi(true);
        const register = `${window.location.origin}/register`;
        console.log(err?.response?.data?.messge, "errr");

        setError("Account doesn't exist. Redirecting you to sign up.");
        setTimeout(() => {
          window.location.href = register;
        }, 3000);
        dispatch(allActions.global.Loader(false));
        console.error("Failed to fetch booking info:", err);
      });
  };

  useEffect(() => {
    const modalElement = document.getElementById("emailAddressModal");

    const handleModalHidden = () => {
      if (!closedByApi) {
        window.location.href = "/register";
      }
    };

    if (modalElement) {
      modalElement.addEventListener("hidden.bs.modal", handleModalHidden);
    }

    return () => {
      if (modalElement) {
        modalElement.removeEventListener("hidden.bs.modal", handleModalHidden);
      }
    };
  }, [closedByApi]);

  return (
    <div className="clearfix" >
      <SEO title="Congratulations!" />
      <div className="page bg-white px-3">
        <button
          data-bs-toggle={"modal"}
          data-bs-target={"#emailAddressModal"}
          className="d-none"
        ></button>
        {loading && (
          <div
            style={{ height: "70vh", display: `${loading ? "flex" : "none"}` }}
            className=" justify-content-center align-items-center "
          >
            <div className="d-flex justify-content-center">
              <div
                className="spinner-border  text-light"
                style={{ width: "6rem", height: "6rem", borderWidth: "10px" }}
                role="status"
              ></div>
            </div>
          </div>
        )}
        <div className="container">
          {!loading && (
            <div className="clearfix w-100 mx-auto text-center mb-5 ">
        <div className="text-center mb-4">
          <h4 className="fw-bold text-primary">
            Select a date and time for a meeting <br />
            with your <span>Tax Professional</span>
          </h4>
          <p className="text-muted">Choose one time slot</p>
        </div>

              <div className="w-100 mx-auto mb-5">
                <OnboardingAppointmentForm
                  appointments={operatorAppointments}
                  lead={leadDetails}
                  setStep ={setStep}
                  isMessageSent={isMessageSent}
                  license={license}
                  isQuestionnaireCompleted={isQuestionnaireCompleted}
                  isPdfDownloaded={isPdfDownloaded}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal
        title="Email Address"
        bodyClass="px-2 py-4 text-center"
        trigger="emailAddressModal"
        btnClass={"closeEmailAddressModal"}
        showBtn={false}
      >
        <div className="text-start w-100">
          <p className="text-muted small mb-3">
            Please enter your email to book an appointment with your Tax
            Professional
          </p>
          <span className="text-danger" style={{ fontSize: "14px" }}>
            {error}
          </span>
          <div className="d-flex align-items-stretch gap-2">
            <input
              type="email"
              className="form-control"
              name="email"
              id="email"
              placeholder="Enter email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button
              disabled={!email}
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default OnBoardingBookAppointment



